import { useGateValue } from '@statsig/react-bindings';

import { EventType } from '@/analytics/types';
import LandingPageHeroChiclet from '@/app/components/LandingPage/LandingPageHero/LandingPageHeroChiclet';
import RichText from '@/app/components/RichText';

import HomeHeroWithChicletWrapper from '../HomeHeroWithChicletWrapper';
import GutfHeroBackground from './common/GiveUsTheFingerHeroBackground';
import GiveUsTheFingerVideoModal from './common/GiveUsTheFingerVideoModal';
import HeroTemplate from './HeroTemplate';

const GiveUsTheFingerHero = () => {
  const gutfIncludeVideoChiclet = useGateValue('give_us_the_finger_chiclet');

  const onVideoModalOpen = () => {
    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'Watch the Film',
      location: 'chiclet',
      action: 'play video',
    });
  };

  const handleClick = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'explore oura ring 4',
      action: 'go to pop',
      location: 'hero',
      path: '/store/rings',
    });
  };

  return (
    <HomeHeroWithChicletWrapper data-cy="gutf-hero-wrapper">
      <HeroTemplate
        background={<GutfHeroBackground />}
        ctaProps={{
          className: 'mb-18 font-bold lg:mb-4 lg:w-auto',
          labelKey: 'explore_oura_ring_4',
          onClick: handleClick,
        }}
        heroName="gutf"
        subtitle={<RichText messageKey="gutf_hero_copy" />}
        title="gutf_hero_title"
      />
      {gutfIncludeVideoChiclet && (
        <div
          className={
            'right-6 bottom-8 z-30 mt-6 flex justify-center px-5 lg:absolute lg:right-14 lg:bottom-11 lg:mt-0'
          }
          data-cy="gutf-hero-chiclet-wrapper"
        >
          <LandingPageHeroChiclet
            className="mb-5! lg:mb-0"
            title="gutf_hero_chiclet_copy"
            modal={{
              Dialog: GiveUsTheFingerVideoModal,
            }}
            modalCta={{
              className: 'w-fit px-0',
              label: 'watch_the_film',
              onClick: onVideoModalOpen,
            }}
            image={{
              format: 'jpg',
              localizedAlt: 'gutf_chiclet_img_alt',
              src: '/gutf-campaign/gutf-chiclet-2.jpg',
            }}
          />
        </div>
      )}
    </HomeHeroWithChicletWrapper>
  );
};

export default GiveUsTheFingerHero;
